module.exports = __webpack_public_path__ + "static/chetab-sma-db6ffb65e82e77cc2ad59a5af819a44e.png";